import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Breadcrumb from 'layouts/main/Breadcrumb';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
//import UIDatePicker from "components/datepicker";
import DateUtil from "utils/DateUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import UISelect from "../../../../components/selectbox/UISelect";
import paramStore from "common/page/store/ParamStore";
import ModalPopup from "../../../../components/modal";
function ContentsContainer() {
	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;

	const [modal2149IsOpen, setModal2149IsOpen] = useState(false);

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count

	const [totalRowCnt_modal,setTotalRowCnt_modal] = useState(0);
	const [showRowCnt_modal,setShowRowCnt_modal] = useState(50); //기본 row count
	const [selectCorp,setSelectCorp] = useState<any>({});
	const [type,setType] = useState('CORP_NM');
	const [searchText_modal,setSearchText_modal] = useState('');


	/** 검색조건 */
	const [bizCd,setBizCd] = useState('');
	const [corpNm, setCorpNm] = useState('');
	const [personNm, setPersonNm] = useState('');
	const [kind, setKind] = useState('');
	const [searchText, setSearchText] = useState('');
	const [tskReqNo, setTskReqNo] = useState('');
	const [tskNm, setTskNm] = useState('');
	const [year, setYear] = useState('');
	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [user, setUser] = useState('');

	//초기 데이터 설정
	let totalCnt:number = 0;
	let rowCnt:number = 20;
	let defaultRowCnt = 20;

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
				{"Header": "No","Name": "RN","Width": "90"}
			],

			"Cols": [
				{"Header": "No","Type": "Int", "Name": "RN","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
				{"Header": "출연사업","Type": "Text","Name": "BIZ_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연기업","Type": "Text","Name": "CORP_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제명","Type": "Text","Name": "TSK_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "수행기업","Type": "Text","Name": "PERF_NMS","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제신청번호","Type": "Text","Name": "TSK_REQ_NO","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제신청상태","Type": "Text","Name": "TSK_REQ_STS_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제신청일","Type": "Date","Name": "TSK_REQ_DATE","RelWidth": 1,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "과제신청금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "집행금액(원)","Type": "Int","Name": "PAY_OUT_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "환수금액(원)","Type": "Int","Name": "REDE_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "환수면제금액(원)","Type": "Int","Name": "EXEMP_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "실제지원기업수","Type": "Int","Name": "PAY_OUT_AMT_COUNT","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제종결여부","Type": "Text","Name": "TSK_CLO_YN","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "재단담당자","Type": "Text","Name": "ADMIN_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "기금사용용도","Type": "Text","Name": "FUN_PUR_USE_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제분야(대분류)","Type": "Text","Name": "BIZ_KIND_NM_1","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제분야(소분류)","Type": "Text","Name": "BIZ_KIND_NM_2","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "정량성과","Type": "Text","Name": "TEXT1","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "정성성과","Type": "Text","Name": "TEXT2","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},

			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('init', '1100');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){

					if(evtParam.col == "PAY_OUT_AMT"){
						//집행금액

						// 다른 페이지로 이동하면서 데이터 전달
						history.push({
							pathname: '/main/usr_2100/usr_2123',
							state: { data: {} }
						});
					}

					if(evtParam.col == "REDE_AMT"){
						//환수금액
						// 다른 페이지로 이동하면서 데이터 전달
						history.push({
							pathname: '/main/usr_2100/usr_2133',
							state: { data: {} }
						});
					}
					if(evtParam.col == "TSK_REQ_NO"){
						var sheet = evtParam.sheet;
						var row = sheet.getFocusedRow();
						sheet.selectRow( row, 1);
						let vTSK_REQ_NO = row["TSK_REQ_NO"].replaceAll('-', '');
						let vTSK_REQ_MODI_SEQ = row["TSK_REQ_MODI_SEQ"];

						let dataToSend = {vTSK_REQ_NO,vTSK_REQ_MODI_SEQ};

						// 다른 페이지로 이동하면서 데이터 전달
						history.push({
							pathname: '/main/usr_2100/usr_2107',
							state: { data: dataToSend }
						});
					}

				}



			},

			onMouseOver:function(evtParam){
				var sheet = evtParam.sheet;
				if (evtParam.row && evtParam.col && evtParam.orow && evtParam.ocol) {

				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					_data = JSON.stringify(d.slice(0, defaultRowCnt), null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}

			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page, 'ib');
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;


			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "통합정보조회"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib.create();

		initCall();


		//필요한 공통코드 로딩.
		codeDataStore.read("cfms.portalBizCdList");


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	function initCall(){
		let start = new Date().getFullYear() - 10;
		let end = new Date().getFullYear() + 10;
		let newYearList = [];
		for(let i = start; i <= end; i++){
			// @ts-ignore
			newYearList.push({value : i+'', nm : i+'년'})
		}
		setYearList(newYearList);
	}


	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			rowCnt = e.target.value;
			ib.create();

		}else if(e.target.name === 'year') {
			setYear(e.target.value);
		}else if(e.target.name === 'type') {
			setType(e.target.value);
		}else if(e.target.name === 'kind') {
			setKind(e.target.value);
		}else if(e.target.name === 'user') {
			setUser(e.target.value);
		}


	};


	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string, actionId) {
		let param = {};
		let url = '';
		if(actionId == '1100'){
			if(sAction =='search'){
				param = {
					"TSK_NM": tskNm,
					"YEAR": year,
					"CORP_NM": corpNm,
					"PERSON_NM": personNm,
					"TSK_REQ_NO": tskReqNo,
					"BIZ_CD": bizCd,
					"KIND": kind,
					"SEARCH_TEXT": searchText,
					"BIZ_NO" : selectCorp.BIZ_NO,
					"USER" : user

				};
			}else{
				param = {

				};
			}
			url = 'adm_1100';


		}else if(actionId == '2149'){
			param = {
				"BIZ_NO":'',
				"CORP_REG_NO":'',
				'CORP_NM': ''
			};
			param[type] = searchText_modal;

			url = 'popup_search_corp';
		}

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url: url,
			data: param
		})



		//전체데이터
		let result = response.REC;


		//전체ROW개수
		totalCnt = Object.keys(result).length;


		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		if(actionId == '1100'){
			//데이터 처리
			ib.data = result;
			setTotalRowCnt(Object.keys(result).length);


			// @ts-ignore
			sheet.loadSearchData(result);  //data 로딩 처리
			// @ts-ignore
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1, 'ib'); // 페이지 초기화

		}else{
			//데이터 처리
			ib_modal.data = result;
			setTotalRowCnt_modal(Object.keys(result).length);


			// @ts-ignore
			sheet_modal.loadSearchData(result);  //data 로딩 처리
			// @ts-ignore
			sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(sheet_modal.getPageIndex( sheet_modal.getFocusedPage()) + 1, 'modal'); // 페이지 초기화
		}


	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, type) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			let elId = 'pageNavi';
			if(type == 'modal'){
				elId = 'modal_pageNavi';
			}

			// @ts-ignore
			if (document.getElementById(elId).firstChild) {
				// @ts-ignore
				document.getElementById(elId).removeChild(document.getElementById(elId).firstChild);
			}


			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt; // 페이지당 레코드 수
			if(type == 'modal') page = showRowCnt_modal

			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, 1);
				else addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, tp - 1);
				else addEventHandler(li, 'click', pageMove, tp - 1);

				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);

					if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, i);
					else addEventHandler(li, 'click', pageMove, i);

					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, tp + 1);
				else addEventHandler(li, 'click', pageMove, tp + 1);

				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';

				if(type == 'modal') addEventHandler(li, 'click', pageMove_modal, lastpage);
				else addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';

			// @ts-ignore
			document.getElementById(elId).appendChild(ul);


		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동
	// @ts-ignore
	const pageMove_modal = function (cPage:number) {
		// @ts-ignore
		sheet_modal.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

		async function onClose(num) {
		if(num == '2149'){
			setModal2149IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
		}
	}

	async function onAfterOpen(num) {

		ib_modal.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}

	}

		//====== 그리드 공통 부 START
	var ib_modal = ib_modal||{};
	ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			/*"LeftCols": [
				{"Header": "No","Name": "RN","Width": "90"}
			],*/
			"Cols": [
				{"Header": "기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "법인등록번호","Type": "Text","Name": "CORP_REG_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0","CustomFormat": "######-#######"},
				{"Header": "사업자등록번호","Type": "Text","Name": "BIZ_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0","CustomFormat": "###-##-#####"},
				{"Header": "대표자","Type": "Text","Name": "CEO_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "규모","Type": "Text","Name": "CORP_SIZE_CD_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				doSearch('init', '2149');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					var row = sheet.getFocusedRow();
					setSelectCorp(row);
					onClose('2149');
				}
			},
			//시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
			onRenderFinish  :function(evtParam){



			},
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}


			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page, 'modal');
				}

				sheet.getDataRows().map(e => {
					e.Visible = 1;
					return e;
				})

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//sheetId
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'modal_2149_List', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				//data: this.data // 생성될 시트의 정적데이터
			});


			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}





	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={3} lnbIdx={0}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">통합정보조회</h1>
					<form className="sf sf-3col">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">과제년도</p>
								<div className="sf-value">
									<div className="sl sl-md w200">
										<select name="year" id="year" value={year} onChange={(handleSelect)}>
											<option value="">전체</option>
											{yearList.map((year, idx) => (
												<option value={year.value}>{year.nm}</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연기업</p>
								<div className="sf-value">
									<div className="hz-root hz-gap8">
										<UIInput className={'hz-item hz-fg tf tf-md'} value={selectCorp.CORP_NM} placeholder={''} />
										<Button color="gray-o" size="md" onClick={() => {setModal2149IsOpen(true); }}>출연기업찾기</Button>
										<Button color="gray-o" size="md" onClick={() => {setSelectCorp({})}}>삭제</Button>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">수행기관</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => {setCorpNm(value)}} placeholder={'수행기업명을 입력하세요.'} />
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">담당자</p>
								<div className="sf-value">
									<div className="hz-root hz-gap8 w100p">
										<div className="sl sl-md w120">
											<select name="user" id="user" value={user} onChange={(handleSelect)}>
												<option value="">전체</option>
												<option value="CORP">기업담당자</option>
												<option value="ADMIN">재단담당자</option>
											</select>
										</div>
										<UIInput className={'hz-item hz-fg tf tf-md'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={'담당자를 입력하세요.'} readOnly={false} />
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제명</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={tskNm} valueChanged={(value) => {setTskNm(value)}} placeholder={'과제명을 입력하세요.'} readOnly={false} />
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제신청번호</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={tskReqNo} valueChanged={(value) => {setTskReqNo(value)}} placeholder={'과제명신청번호를 입력하세요(숫자만입력)'} readOnly={false} />
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연사업</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">조회조건</p>
								<div className="sf-value">
									<div className="hz-root hz-gap8 w100p">
										<div className="sl sl-md w120">
											<select name="kind" id="kind" value={kind} onChange={(handleSelect)}>
												<option value="">전체</option>
												<option value="EXE">정량성과</option>
												<option value="QUE">정성성과</option>
												<option value="BIZ">과제분야</option>
											</select>
										</div>
										<UIInput className={'hz-item hz-fg tf tf-md'} value={searchText} valueChanged={(value) => {setSearchText(value)}} placeholder={'조회조건을 입력하세요.'} />
									</div>
								</div>
							</div>

						</div>
					</form>
					<div className="hz-root hz-center mb30">
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={() => doSearch('search', '1100')}>조회</button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>
					<div id='sheetDiv' >[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>

			{/* modal - 기업검색 */}
			<ModalPopup
				open={modal2149IsOpen}
				title="기업검색"
				size="mid"
				onClose={() => onClose('2149')}
				onAfterOpen={() => onAfterOpen('2149')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<div className="tb-search-form bd mb30">
							<div className="hz-root hz-center hz-gap8">
								<div className="hz-item sl sl-md">
									<select name={'selectType'} value={type} onChange={(handleSelect)}>
										<option value={"CORP_NM"}>기업명</option>
										<option value={"CORP_REG_NO"}>법인사업자번호</option>
										<option value={"BIZ_NO"}>사업자등록번호</option>
									</select>
								</div>
								<UIInput className={'hz-item tf tf-md'} value={searchText_modal} valueChanged={(value) => setSearchText_modal(value)} placeholder={"입력하세요."} />
								<Button color="pri" size="md" onClick={() => doSearch('search', '2149')}>조회</Button>
							</div>
						</div>

						<div className="tb-top">
							<div>
								<p className="tx fc-black">총 <em className="fw500">{totalRowCnt_modal}</em>건</p>
							</div>
							<div className="hz-root hz-gap8">
								<div className="sl sl-sm w120">
									<select name="showRowCnt_modal" id="showRowCnt_modal" value={showRowCnt_modal}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div id="modal_2149_List" >[D] IBSHEET 영역</div>
						<div id="modal_pageNavi" className="pg"></div>
					</div>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;